<template>
  <div>
    <a
      class="btn btn-primary"
      href="/admin/vacation"
    >Back</a>

    <div><h4>Year: {{ year }}</h4></div>
    <div
      v-if="leaveType === 'vacation'"
      class="card my-3"
    >
      <div class="card-header bg-primary-light">
        <div class="card-title">
          <h3 class="mb-0">
            Encashment List
          </h3>
        </div>
      </div>
      <div class="card-body">
        <encashment-list-table
          :staff-id="staffId"
          :year="year"
          :is-manager="isManager"
        />
      </div>
    </div>

    <div class="card my-3">
      <div class="card-header bg-primary-light">
        <div class="card-title">
          <h3 class="mb-0">
            {{ leaveType === "vacation" ? "Vacations" : "Sick Leaves" }} List
          </h3>
        </div>
      </div>
      <div class="card-body">
        <vacation-list-table
          :staff-id="staffId"
          :vacation-list="vacationList"
          :year="year"
          :is-manager="isManager"
          :leave-type="leaveType"
          @get-list="fetchList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import VacationListTable from "./elements/VacationListTable.vue";
import EncashmentListTable from "./elements/EncashmentListTable.vue";

export default {
    name: "StaffVacationList",
    components: { EncashmentListTable, VacationListTable },
    props: {
        staffId: {
            type: Number,
            required: true,
        },
        year: {
            type: Number,
            required: true,
        },
        currentStaffId: {
            type: Number,
            required: true,
        },
        leaveType: {
            type: String,
            required: false,
            default: "vacation",
        },
    },
    computed: {
        staff() {
            if (this.vacationList.length === 0) return false;
            return this.vacationList[0].staff;
        },
        isManager() {
            return this.currentStaffId === 1;
        },
        vacationList() {
            if (this.leaveType === "vacation") {
                return this.$store.getters["vacation/vacationList"];
            } else {
                return this.$store.getters["vacation/sickLeaveList"];
            }
        },
    },
    mounted() {
        this.fetchList(this.leaveType);
    },
    methods: {
        fetchList(type) {
            this.getVacationList({
                staffId: this.staffId,
                year: this.year,
                manager: this.isManager,
                leaveType: type,
            });
        },
        ...mapActions({
            getVacationList: "vacation/getStaffVacations",
        }),
    },
};
</script>
